import { render, staticRenderFns } from "./MonitorAlarm.vue?vue&type=template&id=f8030564"
import script from "./MonitorAlarm.vue?vue&type=script&lang=js"
export * from "./MonitorAlarm.vue?vue&type=script&lang=js"
import style0 from "./MonitorAlarm.vue?vue&type=style&index=0&id=f8030564&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports